import { makeStyles } from "@material-ui/core";

// Paleta alinhada ao dashboard EXPEDIÇÃO
const C = {
  bg: "#f5f7fb",
  card: "#ffffff",
  border: "#e5e9f0",
  line: "#eef1f5",
  slate: "#1e293b",
  slate2: "#334155",
  text: "#1f2933",
  muted: "#6b7280",
  danger: "#dc2626",
  dangerSoft: "#fef2f2",
  green: "#12965a",
  greenSoft: "#dcfce7",
  orange: "#e07b3c",
  primary: "#2563eb",
  primarySoft: "#dbeafe",
};

const stylePagesEmbarque = makeStyles((theme) => ({
  root: {},

  // ── PÁGINA ─────────────────────────────────────────────────────────────
  pageWrap: {
    padding: "24px 8px",
    fontFamily: "'Inter', 'Segoe UI', Roboto, Arial, sans-serif",
    color: C.text,
  },

  pageHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
    marginBottom: 20,
  },

  headerText: {
    "& h1": {
      margin: 0,
      fontSize: 28,
      fontWeight: 800,
      color: C.slate,
      letterSpacing: "-0.01em",
    },
    "& p": {
      margin: "4px 0 0",
      fontSize: 13,
      color: C.muted,
    },
  },

  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },

  newBtn: {
    background: C.slate,
    color: "#fff",
    padding: "10px 20px",
    borderRadius: 10,
    fontWeight: 700,
    fontSize: 13,
    textTransform: "none",
    boxShadow: "0 4px 12px rgba(15,23,42,.18)",
    letterSpacing: ".02em",
    "&:hover": {
      background: "#0f172a",
    },
  },

  holidayBtn: {
    background: C.card,
    color: C.slate,
    padding: "9px 18px",
    borderRadius: 10,
    fontWeight: 700,
    fontSize: 13,
    textTransform: "none",
    borderColor: C.border,
    letterSpacing: ".02em",
    "&:hover": {
      background: C.line,
      borderColor: C.slate2,
    },
  },

  // ── TOOLBAR ────────────────────────────────────────────────────────────
  toolbar: {
    display: "flex",
    gap: 12,
    alignItems: "center",
    marginBottom: 16,
    padding: "12px 16px",
    background: C.card,
    border: `1px solid ${C.border}`,
    borderRadius: 12,
    boxShadow: "0 1px 3px rgba(16,24,40,.04)",
  },

  searchInput: {
    flex: 1,
    "& .MuiOutlinedInput-root": {
      background: C.line,
      borderRadius: 8,
      fontSize: 14,
      "& fieldset": { borderColor: "transparent" },
      "&:hover fieldset": { borderColor: C.border },
      "&.Mui-focused fieldset": { borderColor: C.primary, borderWidth: 2 },
    },
    "& input": {
      padding: "10px 14px",
    },
  },

  counter: {
    fontSize: 13,
    color: C.muted,
    fontWeight: 600,
    whiteSpace: "nowrap",
    "& strong": {
      color: C.slate,
      fontSize: 16,
      marginRight: 4,
    },
  },

  // ── CARD DA TABELA ─────────────────────────────────────────────────────
  tableCard: {
    background: C.card,
    border: `1px solid ${C.border}`,
    borderRadius: 12,
    boxShadow: "0 1px 3px rgba(16,24,40,.04)",
    overflow: "hidden",
  },

  tableCarriers: {
    width: "100%",
    borderCollapse: "collapse",

    "& th": {
      background: C.slate,
      color: "#e2e8f0",
      padding: "14px 12px",
      fontSize: 11,
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: ".05em",
      textAlign: "center",
      borderBottom: `1px solid ${C.slate2}`,
      "&:first-child": { textAlign: "left", paddingLeft: 20 },
      "&:last-child": { paddingRight: 20 },
    },
    "& td": {
      padding: "12px 12px",
      fontSize: 13,
      color: C.text,
      borderBottom: `1px solid ${C.line}`,
      textAlign: "center",
      verticalAlign: "middle",
      "&:first-child": { textAlign: "left", paddingLeft: 20, fontWeight: 600 },
      "&:last-child": { paddingRight: 20 },
    },
    "& tbody tr": {
      transition: "background .12s",
      "&:hover": { background: "#f8fafc" },
      "&:last-child td": { borderBottom: "none" },
    },
  },

  emptyState: {
    padding: "48px 20px",
    textAlign: "center",
    color: C.muted,
    fontSize: 14,
    "& strong": { color: C.slate },
  },

  // ── TIME BADGES na tabela ──────────────────────────────────────────────
  timeBadge: {
    display: "inline-block",
    padding: "4px 10px",
    background: C.line,
    color: C.slate,
    borderRadius: 6,
    fontFamily: "'Space Mono', 'Roboto Mono', monospace",
    fontSize: 12,
    fontWeight: 700,
  },

  daysBadge: {
    display: "inline-block",
    padding: "3px 10px",
    background: C.primarySoft,
    color: C.primary,
    borderRadius: 10,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: ".02em",
  },

  // Porte do pedido que a transportadora leva (order_size)
  sizeBadge: {
    display: "inline-block",
    padding: "3px 10px",
    borderRadius: 10,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: ".02em",
    "&.pequeno": { background: "#fff3e0", color: "#b45309" },
    "&.medio": { background: "#e8f0fe", color: "#1a56db" },
    "&.grande": { background: "#e6f6ed", color: "#12965a" },
  },

  statusBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 10px",
    borderRadius: 12,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: ".03em",
    textTransform: "uppercase",
    "&.active": {
      background: C.greenSoft,
      color: C.green,
    },
    "&.inactive": {
      background: C.line,
      color: C.muted,
    },
    "& .dot": {
      width: 6,
      height: 6,
      borderRadius: "50%",
      background: "currentColor",
    },
  },

  actionBtn: {
    padding: 6,
    borderRadius: 8,
    color: C.muted,
    transition: "all .12s",
    "&:hover": {
      background: C.primarySoft,
      color: C.primary,
    },
    "&.danger:hover": {
      background: C.dangerSoft,
      color: C.danger,
    },
  },

  // ── MODAL ──────────────────────────────────────────────────────────────
  modalBox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "92%",
    maxWidth: 780,
    maxHeight: "92vh",
    background: C.card,
    borderRadius: 14,
    boxShadow: "0 24px 64px rgba(0,0,0,.35)",
    outline: "none",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    fontFamily: "'Inter', 'Segoe UI', Roboto, Arial, sans-serif",
  },

  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "18px 24px",
    background: C.slate,
    color: "#fff",

    "& h2": {
      margin: 0,
      fontSize: 20,
      fontWeight: 800,
      color: "#fff",
      letterSpacing: "-0.01em",
    },
    "& .subtitle": {
      display: "block",
      fontSize: 12,
      color: "#94a3b8",
      fontWeight: 500,
      marginTop: 2,
    },
    "& .closeBtn": {
      color: "#cbd5e1",
      "&:hover": {
        background: "rgba(255,255,255,.08)",
        color: "#fff",
      },
    },
  },

  modalBody: {
    padding: "24px",
    overflowY: "auto",
    flex: 1,
    background: "#fafbfc",

    "&::-webkit-scrollbar": { width: 8 },
    "&::-webkit-scrollbar-thumb": { background: "#cbd5e1", borderRadius: 4 },
  },

  modalFooter: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
    padding: "16px 24px",
    background: C.card,
    borderTop: `1px solid ${C.border}`,
  },

  cancelBtn: {
    padding: "8px 20px",
    borderRadius: 8,
    color: C.muted,
    fontWeight: 600,
    textTransform: "none",
    fontSize: 13,
    "&:hover": {
      background: C.line,
    },
  },

  submitBtn: {
    background: C.slate,
    color: "#fff",
    padding: "8px 24px",
    borderRadius: 8,
    fontWeight: 700,
    textTransform: "none",
    fontSize: 13,
    boxShadow: "0 4px 10px rgba(15,23,42,.18)",
    "&:hover": {
      background: "#0f172a",
    },
    "&.Mui-disabled": {
      background: "#94a3b8",
      color: "#fff",
    },
  },

  // Cards internos do modal (Tempos, Dias, Opções)
  formSection: {
    background: C.card,
    border: `1px solid ${C.border}`,
    borderRadius: 10,
    padding: "18px 20px",
    marginBottom: 14,
    boxShadow: "0 1px 2px rgba(16,24,40,.03)",
  },

  sectionTitle: {
    fontSize: 11,
    fontWeight: 800,
    color: C.slate,
    textTransform: "uppercase",
    letterSpacing: ".08em",
    marginBottom: 14,
    display: "flex",
    alignItems: "center",
    gap: 8,
    "&::before": {
      content: '""',
      display: "inline-block",
      width: 4,
      height: 14,
      background: C.slate,
      borderRadius: 2,
    },
  },

  daysWrap: {
    display: "flex",
    flexWrap: "wrap",
    gap: 4,
    marginTop: 8,
  },

  presetsRow: {
    display: "flex",
    gap: 8,
    marginBottom: 12,
  },

  // ── ENTREGA EXPRESSA (prazo em horas) ──────────────────────────────────
  // Seletor "Em dias / Em horas", acima dos campos de tempo.
  modeRow: {
    marginBottom: 12,
    "& .MuiFormControlLabel-label": { fontSize: 13 },
  },

  // Explica por que corte/tolerância/dias ficaram apagados no modo horas.
  modeHint: {
    marginTop: 12,
    fontSize: 12,
    lineHeight: 1.45,
    color: C.muted,
    background: C.line,
    borderRadius: 8,
    padding: "10px 12px",
  },

  // Seção inteira que não participa do cálculo expresso.
  sectionMuted: {
    opacity: 0.55,
  },

  notApplies: {
    marginLeft: "auto",
    textTransform: "none",
    letterSpacing: 0,
    fontSize: 11,
    fontWeight: 600,
    color: C.muted,
  },

  // Marca a linha expressa na listagem — sem ele, "3h" na coluna Expedição
  // se confunde com um horário.
  expressBadge: {
    display: "inline-block",
    marginLeft: 8,
    padding: "2px 8px",
    background: C.primarySoft,
    color: C.primary,
    borderRadius: 10,
    fontSize: 10,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: ".04em",
  },

  presetBtn: {
    borderRadius: 8,
    fontSize: 12,
    fontWeight: 600,
    textTransform: "none",
    padding: "4px 14px",
    borderColor: C.border,
    color: C.slate2,
    "&:hover": {
      background: C.primarySoft,
      borderColor: C.primary,
      color: C.primary,
    },
  },

  titlePage: {
    fontSize: 20,
    fontWeight: 700,
    color: C.slate,
    margin: 0,
  },

  // ── legado (mantidos por compat) ───────────────────────────────────────
  topBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
    margin: "14px 0 10px",
  },
  boxFilter: {},
  buttonsDowload: {},
  dateRanking: {},
  totalOrders: {},
  exportExcel: {},
  formContainer: {},
  formField: {},
  submitButton: {},
  GridDate: {},
}));

export default stylePagesEmbarque;
